import { useQuery, UseQueryResult } from 'react-query';
import axiosInstance from '../api/_http';
import { ApiResponse } from '../libs/apiResponse';

export function usePublicManager() {

  function useFetchCountries(): UseQueryResult<ApiResponse<{
    id: number;
    label: string;
  }[]>, Error> {
    return useQuery<ApiResponse<{
      id: number;
      label: string;
    }[]>, Error>('fetchCountries', async () => {
      const { data } = await axiosInstance.get<ApiResponse<{
        id: number;
        label: string;
      }[]>>('/api/2.0/public/countries');
      return data;
    });
  }

  function useFetchRoles(): UseQueryResult<ApiResponse<{
    id: number;
    label: string;
  }[]>, Error> {
    return useQuery<ApiResponse<{
      id: number;
      label: string;
    }[]>, Error>('fetchRoles', async () => {
      const { data } = await axiosInstance.get<ApiResponse<{
        id: number;
        label: string;
      }[]>>('/api/2.0/public/roles');
      return data;
    });
  }

  function useFetchSectors(): UseQueryResult<ApiResponse<{
    id: number;
    label: string;
  }[]>, Error> {
    return useQuery<ApiResponse<{
      id: number;
      label: string;
    }[]>, Error>('fetchSectors', async () => {
      const { data } = await axiosInstance.get<ApiResponse<{
        id: number;
        label: string;
      }[]>>('/api/2.0/public/sectors');
      return data;
    });
  }

  return {
    useFetchCountries,
    useFetchRoles,
    useFetchSectors
  };
}


